(() => {
  const clamp = (value, min, max) => Math.min(max, Math.max(min, value));
  function initMycelium(host) {
    const controller = new AbortController();
    const motion = window.matchMedia("(prefers-reduced-motion: reduce)");
    let reduceMotion = motion.matches;
    let paused = reduceMotion;
    let raf = 0;
    let elapsed = 0;
    let destroyed = false;
    const toggle = host.querySelector("button");
    var canvas = host.querySelector("canvas");
    if (!canvas || !canvas.getContext) return;
    var hero = host.parentElement;
    var ctx = canvas.getContext('2d');
    if (!ctx) return;

    var rgb = [160, 232, 189];
    function rgba(a) { return 'rgba(' + rgb[0] + ',' + rgb[1] + ',' + rgb[2] + ',' + a + ')'; }

    var BASE = [
      [0.06, 0.78, 2.4], [0.16, 0.55, 3], [0.27, 0.82, 2.4], [0.33, 0.38, 2.6], [0.46, 0.7, 3.2], [0.5, 0.2, 2.4],
      [0.58, 0.52, 3.6], [0.66, 0.86, 2.4], [0.72, 0.3, 3.2], [0.8, 0.62, 3.6], [0.86, 0.18, 2.4], [0.93, 0.45, 3],
      [0.9, 0.88, 2.4], [0.2, 0.15, 2.2], [0.4, 0.93, 2], [0.62, 0.08, 2]
    ];
    var LINKS = [
      [0, 1, 0.15], [1, 2, -0.2], [1, 3, 0.18], [3, 4, -0.15], [2, 4, 0.2], [3, 5, 0.2], [4, 6, 0.12], [5, 6, -0.18],
      [6, 7, 0.2], [6, 8, 0.15], [8, 9, -0.2], [8, 10, 0.2], [9, 11, 0.15], [9, 12, -0.2], [7, 9, 0.1], [11, 10, 0.2],
      [1, 13, 0.25], [13, 3, -0.2], [4, 14, 0.2], [5, 15, -0.15], [15, 8, 0.18]
    ];

    var reach = 260;
    var W = 1, H = 1, dpr = 1;
    var nodes = BASE.map(function () { return { x: 0, y: 0, g: 0, ox: 0, oy: 0, h: 0 }; });
    var spores = [];
    var cur = { x: 0, y: 0, tx: 0, ty: 0, s: 0, active: false };
    var userTouched = false;
    var visible = true;
    var running = false;
    var t0 = performance.now();
    var last = t0;
    var releaseTimer;

    function makeSpore(initial) {
      return {
        x: Math.random() * W,
        y: initial ? Math.random() * H : H + 10 + Math.random() * 40,
        vy: 14 + Math.random() * 26,
        size: 1 + Math.random() * 2.2,
        phase: Math.random() * Math.PI * 2,
        sway: 8 + Math.random() * 22
      };
    }

    function initSpores() {
      var count = 26;
      if (isNaN(count)) count = 26;
      if (W < 640) count = Math.round(count * 0.6);
      spores = [];
      for (var i = 0; i < count; i++) spores.push(makeSpore(true));
    }

    function resize() {
      var r = canvas.getBoundingClientRect();
      W = Math.max(1, r.width);
      H = Math.max(1, r.height);
      dpr = Math.min(window.devicePixelRatio || 1, 2);
      canvas.width = Math.round(W * dpr);
      canvas.height = Math.round(H * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      initSpores();
      if (paused) draw(100, 0.016);
    }

    function ease(p) { return 1 - Math.pow(1 - p, 3); }

    function draw(t, dt) {
      var k;
      var ease10 = Math.min(1, dt * 10);
      var ease8 = Math.min(1, dt * 8);

      
      var targetStrength = 0;
      if (cur.active) {
        targetStrength = 1;
      } else if (!userTouched && !reduceMotion) {
        cur.tx = W * (0.58 + 0.28 * Math.sin(t * 0.33));
        cur.ty = H * (0.5 + 0.26 * Math.cos(t * 0.27));
        targetStrength = 0.55;
      }
      cur.x += (cur.tx - cur.x) * ease10;
      cur.y += (cur.ty - cur.y) * ease10;
      cur.s += (targetStrength - cur.s) * Math.min(1, dt * 4);

      ctx.clearRect(0, 0, W, H);

      
      if (cur.s > 0.01) {
        var grad = ctx.createRadialGradient(cur.x, cur.y, 0, cur.x, cur.y, 200);
        grad.addColorStop(0, rgba(0.2 * cur.s));
        grad.addColorStop(1, rgba(0));
        ctx.fillStyle = grad;
        ctx.fillRect(cur.x - 200, cur.y - 200, 400, 400);
      }

      
      var i;
      for (i = 0; i < BASE.length; i++) {
        var n = nodes[i];
        var bx = BASE[i][0] * W;
        var by = BASE[i][1] * H;
        var g = 0, tox = 0, toy = 0;
        if (cur.s > 0.01) {
          var dx = cur.x - bx, dy = cur.y - by;
          var d = Math.sqrt(dx * dx + dy * dy) || 1;
          if (d < reach) {
            g = (1 - d / reach) * cur.s;
            var pull = g * 22;
            tox = (dx / d) * pull;
            toy = (dy / d) * pull;
          }
        }
        n.g += (g - n.g) * ease8;
        n.ox += (tox - n.ox) * ease8;
        n.oy += (toy - n.oy) * ease8;
        n.x = bx + n.ox + Math.sin(t * 0.4 + i) * 3;
        n.y = by + n.oy + Math.cos(t * 0.35 + i * 1.3) * 3;
      }

      
      ctx.lineCap = 'round';
      for (i = 0; i < LINKS.length; i++) {
        var l = LINKS[i];
        var a = nodes[l[0]], b = nodes[l[1]];
        var p = ease(clamp((t - 0.3 - i * 0.35) / 2.4, 0, 1));
        if (p <= 0) continue;
        var gg = (a.g + b.g) / 2;
        var mx = (a.x + b.x) / 2, my = (a.y + b.y) / 2;
        var ddx = b.x - a.x, ddy = b.y - a.y;
        var qx = mx - ddy * l[2], qy = my + ddx * l[2];
        ctx.strokeStyle = rgba(0.34 + gg * 0.55);
        ctx.lineWidth = 1.1 + gg * 1.6;
        ctx.beginPath();
        ctx.moveTo(a.x, a.y);
        var steps = Math.max(2, Math.ceil(28 * p));
        for (k = 1; k <= steps; k++) {
          var u = (p * k) / steps, q = 1 - u;
          ctx.lineTo(q * q * a.x + 2 * q * u * qx + u * u * b.x, q * q * a.y + 2 * q * u * qy + u * u * b.y);
        }
        ctx.stroke();
      }

      
      var order = [];
      for (i = 0; i < nodes.length; i++) {
        order.push({ i: i, d: Math.hypot(cur.x - nodes[i].x, cur.y - nodes[i].y) });
      }
      order.sort(function (u1, v1) { return u1.d - v1.d; });
      var near = {};
      for (k = 0; k < 3; k++) {
        if (cur.s > 0.05 && order[k].d < 480 && order[k].d > 8) near[order[k].i] = k;
      }
      ctx.shadowColor = rgba(0.9);
      ctx.shadowBlur = 8;
      for (i = 0; i < nodes.length; i++) {
        var nd = nodes[i];
        var target = near[i] !== undefined ? 1 : 0;
        nd.h += (target - nd.h) * Math.min(1, dt * (target ? 5 : 3));
        if (nd.h < 0.02) continue;
        var rank = near[i] !== undefined ? near[i] : 2;
        var sgn = i % 2 === 0 ? 1 : -1;
        var vx = cur.x - nd.x, vy = cur.y - nd.y;
        var c1x = nd.x + vx * 0.3 - vy * 0.2 * sgn, c1y = nd.y + vy * 0.3 + vx * 0.2 * sgn;
        var c2x = nd.x + vx * 0.7 + vy * 0.14 * sgn, c2y = nd.y + vy * 0.7 - vx * 0.14 * sgn;
        ctx.strokeStyle = rgba((0.95 - rank * 0.25) * nd.h);
        ctx.lineWidth = 2 - rank * 0.5;
        ctx.beginPath();
        ctx.moveTo(nd.x, nd.y);
        var hs = Math.max(2, Math.ceil(30 * nd.h));
        for (k = 1; k <= hs; k++) {
          var hu = (nd.h * k) / hs, hq = 1 - hu;
          var px = hq * hq * hq * nd.x + 3 * hq * hq * hu * c1x + 3 * hq * hu * hu * c2x + hu * hu * hu * cur.x;
          var py = hq * hq * hq * nd.y + 3 * hq * hq * hu * c1y + 3 * hq * hu * hu * c2y + hu * hu * hu * cur.y;
          ctx.lineTo(px, py);
        }
        ctx.stroke();
      }
      ctx.shadowBlur = 0;

      
      for (i = 0; i < nodes.length; i++) {
        var node = nodes[i];
        var appear = clamp((t - 0.3 - i * 0.25) / 1, 0, 1);
        if (appear <= 0) continue;
        var pulse = 0.6 + 0.4 * Math.sin(t * 1.2 + i);
        ctx.fillStyle = rgba((0.12 + node.g * 0.35) * pulse * appear);
        ctx.beginPath();
        ctx.arc(node.x, node.y, BASE[i][2] * 3.4 + node.g * 14, 0, Math.PI * 2);
        ctx.fill();
        ctx.fillStyle = rgba((0.75 + node.g * 0.25) * appear);
        ctx.beginPath();
        ctx.arc(node.x, node.y, BASE[i][2] + node.g * 4, 0, Math.PI * 2);
        ctx.fill();
      }

      
      if (cur.s > 0.05 && cur.active) {
        ctx.fillStyle = rgba(0.16 * cur.s);
        ctx.beginPath();
        ctx.arc(cur.x, cur.y, 22, 0, Math.PI * 2);
        ctx.fill();
        ctx.fillStyle = rgba(cur.s);
        ctx.beginPath();
        ctx.arc(cur.x, cur.y, 4, 0, Math.PI * 2);
        ctx.fill();
      }

      
      for (i = 0; i < spores.length; i++) {
        var s = spores[i];
        if (!reduceMotion) {
          s.y -= s.vy * dt;
          s.x += Math.sin(t * 0.6 + s.phase) * s.sway * dt;
          if (cur.s > 0.05 && cur.active) {
            var sx = s.x - cur.x, sy = s.y - cur.y;
            var sd = Math.sqrt(sx * sx + sy * sy) || 1;
            if (sd < 120) { s.x += (sx / sd) * (120 - sd) * dt * 2; s.y += (sy / sd) * (120 - sd) * dt * 2; }
          }
          if (s.y < -12) spores[i] = s = makeSpore(false);
        }
        var life = clamp((H - s.y) / H, 0, 1);
        var alpha = Math.sin(life * Math.PI) * 0.9;
        if (alpha <= 0.02) continue;
        ctx.fillStyle = rgba(alpha);
        ctx.shadowColor = rgba(0.9);
        ctx.shadowBlur = s.size * 4;
        ctx.beginPath();
        ctx.arc(s.x, s.y, s.size, 0, Math.PI * 2);
        ctx.fill();
      }
      ctx.shadowBlur = 0;
    }

    function frame(now) {
      if (!visible || document.hidden || paused || destroyed) { running = false; return; }
      var dt = Math.min(0.05, (now - last) / 1000);
      last = now;
      elapsed += dt;
      draw(elapsed, dt);
      raf = requestAnimationFrame(frame);
    }

    function start() {
      if (running || paused || destroyed || !visible || document.hidden) return;
      running = true;
      last = performance.now();
      raf = requestAnimationFrame(frame);
    }

    function setPointer(e) {
      if (paused) return;
      var r = canvas.getBoundingClientRect();
      cur.tx = e.clientX - r.left;
      cur.ty = e.clientY - r.top;
      if (!cur.active) { cur.x = cur.tx; cur.y = cur.ty; }
      cur.active = true;
      userTouched = true;
      clearTimeout(releaseTimer);
    }
    function release(e) {
      clearTimeout(releaseTimer);
      if (e && e.pointerType === 'touch') {
        releaseTimer = setTimeout(function () { cur.active = false; }, 900);
      } else {
        cur.active = false;
      }
    }

    const options = { passive: true, signal: controller.signal };
    hero.addEventListener('pointermove', setPointer, options);
    hero.addEventListener('pointerdown', setPointer, options);
    hero.addEventListener('pointerleave', release, options);
    hero.addEventListener('pointerup', release, options);
    hero.addEventListener('pointercancel', release, options);
    const observer = new ResizeObserver(resize);
    observer.observe(hero);
    const intersection = new IntersectionObserver(entries => {
      visible = entries[0].isIntersecting;
      if (visible) start();
    });
    intersection.observe(hero);
    document.addEventListener('visibilitychange', () => { if (!document.hidden) start(); }, options);
    function updateButton() {
      toggle.textContent = paused ? toggle.dataset.play : toggle.dataset.pause;
      toggle.setAttribute('aria-pressed', String(paused));
    }
    toggle.addEventListener('click', () => {
      paused = !paused;
      reduceMotion = paused;
      if (paused) { cancelAnimationFrame(raf); running = false; }
      else start();
      updateButton();
    }, { signal: controller.signal });
    motion.addEventListener('change', e => {
      paused = reduceMotion = e.matches;
      cancelAnimationFrame(raf); running = false;
      if (paused) draw(100, 0.016); else start();
      updateButton();
    }, { signal: controller.signal });
    resize();
    updateButton();
    start();
    return () => {
      destroyed = true;
      cancelAnimationFrame(raf);
      clearTimeout(releaseTimer);
      observer.disconnect();
      intersection.disconnect();
      controller.abort();
    };
  }
  if (!customElements.get('gzl-mycelium')) {
    customElements.define('gzl-mycelium', class extends HTMLElement {
      connectedCallback() { if (!this.cleanup) this.cleanup = initMycelium(this); }
      disconnectedCallback() { if (this.cleanup) this.cleanup(); this.cleanup = null; }
    });
  }
})();
